// extracted by mini-css-extract-plugin
var _1 = "EmailProfileActionsWidgetSkeleton-modulearrow__T5P8G ProfileActionsWidgetSkeleton-moduleaction__FK8In Skeleton-moduleSkeleton__Mlrfv";
var _2 = "EmailProfileActionsWidgetSkeleton-modulecounter__E8dSg Skeleton-moduleSkeleton__Mlrfv";
var _3 = "EmailProfileActionsWidgetSkeleton-modulenavigation__Qz7by EntityProfileNavigation-moduleEntityProfileNavigation__KWjEZ";
export { _1 as "arrow", _2 as "counter", _3 as "navigation" }
